import { useContext } from "react";
import { MobXProviderContext } from "mobx-react";
import { RouterAddress } from "../../../constants/RouterAddress";
import { ROLE_TYPE_MHP } from "../../../constants/RegisterConstants";
import { CaregiverIncidentReportPageContent } from "../../caregiver/pages/CaregiverIncidentReportPage";

const SharedResidentIncidentReportPage = () => {
  const { authStore } = useContext(MobXProviderContext);
  const userRoleType = String(authStore?.getUserRoleType?.() || "").trim().toLowerCase();
  const dashboardPathOverride = userRoleType === ROLE_TYPE_MHP ? RouterAddress.MHP_HOME : RouterAddress.NURSE_HOME;

  return (
    <CaregiverIncidentReportPageContent
      allowSharedStaffAccess
      sharedMode
      dashboardPathOverride={dashboardPathOverride}
    />
  );
};

export default SharedResidentIncidentReportPage;
